import restClient from "../restClient";

export const getDealerSiteDailyStatSummary = async ({ days = 30 } = {}) => {
  const token = localStorage.getItem("token");
  const response = await restClient.get("dealer-site-daily-stats/summary", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: { days },
  });
  return response.data;
};
